import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

// ---------Shared--------------------------------------------
import { TylerMatTableDataSource } from '../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../shared-components/angular-material/mat-animations';
import { AriaDirective } from '../../shared-components/directives/aria.directive';
import { Student } from '../../shared-components/student/student.model';
import { StudentService } from '../../shared-components/student/student.service';
import { UserService } from '../../shared-components/user/user.service';
import { Year } from '../../shared-components/year/year.model';
import { YearService } from '../../shared-components/year/year.service';
import { LoginService } from '../../shared-modules/login/login.service';
import { OnlinePaymentConfiguration } from '../online-payment/models/online-payment-config.model';
import { FeesAndBilling } from './fees-and-billing.model';
import { FeesAndBillingService } from './fees-and-billing.service';

// -------Angular Material------------------------------------
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { StudentHeaderComponent } from '../../shared-components/student-header/student-header.component';

@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'fees-and-billing',
    templateUrl: './fees-and-billing.component.html',
    styleUrls: ['./fees-and-billing.component.scss'],
    animations: [detailExpand]
})
export class FeesAndBillingComponent implements OnInit, AfterViewInit, OnDestroy {

    // ------------Fees And Billing Data---------------------------
    student360YearSubscription: Subscription;
    student360Year: Year;
    selectedStudentSubscription: Subscription;
    selectedStudent: Student;
    feesAndBilling: FeesAndBilling[];
    onlinePaymentConfiguration: OnlinePaymentConfiguration = new OnlinePaymentConfiguration();
    unappliedPayments: number;
    totalBalance: number;
    aYBalance: number;
    priorBalance: number;
    totalUnapplied: number;
    allowFutureYears = false;
    futureBalance = 0;
    // ------------Selection/Flags-----------------------------------
    selected = '0';
    isBusy: boolean;
    parentPortalShowOnlinePayment: boolean;
    userType: number;
    // ----------Angular Material------------------------------------
    angularMatData = new TylerMatTableDataSource();
    @ViewChild(MatSort) sort: MatSort;
    columnsToDisplay: string[] = ['More', 'FeeCode', 'Description', 'Balance', 'BalanceType'];
    initialSelection = [];
    allowMultiSelect = true;
    selection = new SelectionModel<any>(this.allowMultiSelect, this.initialSelection);
    clearFilterEvent = new EventEmitter<any>();
    studentId: number;
    FeeCode: string;
    FeeDialog = false;
    studentname: string;
    studentNumber: string;

    @ViewChild(StudentHeaderComponent) studentHeader: StudentHeaderComponent;
    subscriptions: Subscription[] = [];
    // --------------LifeCycle---------------------------------------

    constructor(private studentService: StudentService,
        private yearService: YearService,
        private userService: UserService,
        private loginService: LoginService,
        private router: Router,
        private feesAndBillingService: FeesAndBillingService,
        public changeDetector: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<FeesAndBillingComponent>) {

        this.parentPortalShowOnlinePayment = this.loginService.LoginSettings.ParentPortalShowOnlinePayment;
        this.userType = this.userService.userType;
        if (data != undefined && data.length != 0 && data.onlinePayment) {
            this.studentId = data.onlinePayment.StudentId;
            this.FeeDialog = data.FeeDialog;
            this.FeeCode = data.onlinePayment.AccountCode;
            this.studentname = data.onlinePayment.StudentName;
            this.studentNumber = data.onlinePayment.StudentIdentifier;
        }
    }

    ngOnInit() {
        this.allowFutureYears = this.loginService.LoginSettings.AllowFutureFeeBillingPayments;
        if (this.studentId > 0 && this.FeeDialog) {
            this.loadStudentInfo(this.studentId);
        }
        else if (this.studentService.selectedStudent) {
            this.loadStudentInfo(this.studentService.selectedStudent.Id);
        }
        if (this.data != undefined && this.data.length == 0) {
            this.subscriptions.push(this.selectedStudentSubscription = this.studentService.selectedStudentStream$.subscribe(
                studentId => {
                    this.feesAndBilling = undefined;
                    this.loadStudentInfo(studentId);
                }));
        }
        this.getOnlinePaymentConfiguration();
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
    }

    // ------------Fees And Billing Data---------------------------
    loadStudentInfo(studentId: number) {
        if (studentId && studentId > 0) {
            this.clearStudentData();
            this.selectedStudent = this.studentService.students.filter(function (student) { return student.Id == studentId; })[0];
            this.student360Year = this.yearService.student360Year;
            this.getFeesAndBilling();
        }
    }

    getFeesAndBilling() {
        this.subscriptions.push(this.feesAndBillingService.getFeesAndBilling(this.selectedStudent.Id, this.student360Year.Id, this.userService.userId).subscribe(result => {
            this.feesAndBilling = result;
            this.angularMatData = new TylerMatTableDataSource(this.feesAndBilling);
            this.calculateBalance();
            this.loadFeesAndBillingData();
        }));
    }

    getOnlinePaymentConfiguration() {
        if (this.loginService.LoginSettings.ParentPortalShowOnlinePayment && this.userService.userType == 2) {
            this.subscriptions.push(this.studentService.getOnlinePaymentConfiguration().subscribe(result => {
                this.onlinePaymentConfiguration = result;
            }));
        }
    }

    private loadFeesAndBillingData(): void {
        if (this.FeeDialog) {
            this.angularMatData.data = this.feesAndBilling.filter(fee => fee.FeeCode === this.FeeCode);
            this.angularMatData.expandAll(true);
        }
        else {
            this.angularMatData.data = this.feesAndBilling;
        }
        this.angularMatData.sort = this.sort;
    }

    clearStudentData() {

    }

    calculateBalance() {
        this.aYBalance = 0;
        this.unappliedPayments = 0;
        this.totalBalance = 0;
        this.priorBalance = 0;
        this.totalUnapplied = 0;

        for (let i = 0; i < this.feesAndBilling.length; i++) {
            if (this.feesAndBilling[i].V10Flag) {
                this.totalUnapplied = this.feesAndBilling[i].Unapplied;
            }
            this.aYBalance = this.aYBalance + this.feesAndBilling[i].AYBalance;
            this.totalBalance = this.totalBalance + this.feesAndBilling[i].BalanceSort;
            for (let j = 0; j < this.feesAndBilling[i].FeePayments.length; j++) {
                this.unappliedPayments = this.unappliedPayments + this.feesAndBilling[i].FeePayments[j].UnappliedPayments;
                if (this.feesAndBilling[i].FeePayments[j].Id == -99) {
                    this.priorBalance = this.priorBalance + parseFloat(this.feesAndBilling[i].FeePayments[j].RunningBalance);
                }
            }
        }
        this.aYBalance = Math.round(this.aYBalance * 100) / 100;
        this.unappliedPayments = Math.round(this.unappliedPayments * 100) / 100;
        this.priorBalance = this.priorBalance;
        this.unappliedPayments = this.unappliedPayments + this.totalUnapplied;
        this.totalBalance = this.totalBalance + this.unappliedPayments;
    }

    getFutureBalance() {
        this.futureBalance = 0;
        this.feesAndBilling.forEach(feeBill => {
            feeBill.FeePayments.forEach(p => {
                if (p.Id == -98) {
                    this.futureBalance += parseFloat(p.RunningBalance);
                }
            });
        });
        // this.totalBalance = this.totalBalance - this.futureBalance;
    }

    onlinePaymentClick() {
        this.router.navigateByUrl('/student360/onlinePayment');
    }

    regEnrollMode() {
        return this.router.url.toLowerCase().indexOf('registrationenrollment') > -1;
    }

    // ------------Helper methods----------------------------------

    removeElement(array: any[], element: any) {
        const index: number = array.indexOf(element);
        array.splice(index, 1);
    }

    // ------------Aria/Accessibility---------------------------

    getAriaRow(row: FeesAndBilling): string {
        // Returns string for a given row's data
        // reads each column header name and then the cell data for that column
        const colList: string[] = ['FeeCode', 'Description', 'Balance', 'Balance Type'];

        const dataList: string[] = [row.FeeCode,
        row.Description,
        row.Balance,
        parseInt(row.Balance, 10) > 0 ? 'Credit' : (parseInt(row.Balance, 10) < 0 ? 'Due' : '')];

        return AriaDirective.concatAriaStrings(colList, dataList);
    }

    // ----------Angular Material------------------------------------
    toggleExpanded(row: any) {
        this.angularMatData.toggleExpanded(row);
    }

    checkExpanded(row: any): boolean {
        return this.angularMatData.checkExpanded(row);
    }

    expandAll(expand: boolean) {
        this.angularMatData.expandAll(expand);
    }

    rowKeyPress(event: KeyboardEvent, row: any) {
        this.angularMatData.rowKeyPress(event, row);
    }

    closeClick() {
        this.dialogRef.close();
    }

    yearChange(year: Year) {
        this.student360Year = year;
        this.getFeesAndBilling();
        if (!this.allowFutureYears) {
            this.yearService.updateStudent360Year(year);
        }
    }
}
